// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Blank from '@/components/Blank'
import router from './router'
import VueAnalytics from 'vue-analytics'

import './assets/scss/main.scss'

Vue.config.productionTip = false

const isProd = process.env.NODE_ENV === 'production'

Vue.use(VueAnalytics, {
  id: 'UA-123777601-1',
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App, Blank },
  template: '<Blank/>'
})



// WEBPACK FOOTER //
// ./src/main.js